var map = {
	"./basketball-active.webp": 1478,
	"./basketball.webp": 1479,
	"./bg.webp": 1480,
	"./football-active.webp": 1481,
	"./football.webp": 1482,
	"./games-active.webp": 1483,
	"./games.webp": 1484,
	"./information.webp": 1485,
	"./live-streaming-cover.webp": 1486,
	"./lv-active-bg.webp": 1487,
	"./video-bg.webp": 1488,
	"./video-icon.webp": 1489,
	"./vs.webp": 1490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 461;